import { Button, Flex, Text, Tooltip } from "@chakra-ui/react";
import StatusBadge from "components/badge/StatusBadge";
import TooltipModal from "components/modal/TooltipModal";
import CustomTooltip from "components/tooltip/CustomTooltip";

export const propertiesColumn = [
  {
    Header: "SID",
    accessor: "sid",
  },
  {
    Header: "POSTED By",
    accessor: "created_by",
  },
  {
    Header: "Phone",
    accessor: "owner_phone",
  },
  {
    Header: "SLUG",
    accessor: "slug_url",
    Cell: ({ value, row }) => {
      const isFeatured = row?.original?.featured
      return (
        <a
          _hover={{ textDecoration: "underline" }}
          href={`${process.env.REACT_APP_HEXAHOME_BASE_URL}/property-details/${value}`}
          target="_blank"
          rel="noreferrer"
          cursor="pointer"
          whiteSpace={"nowrap"}
          style={{ fontSize: "11px", fontWeight: 600, textAlign: "left" }}
        >
          {value} {isFeatured && <StatusBadge label={"featured"} bgColor="blue" />}
        </a>
      );
    },
  },
  {
    Header: "PROPERTY STATUS",
    accessor: "property_status",
    Cell: ({ value }) => (
      <Flex align="center" justify={"center"}>
        <Text>
          <StatusBadge status={value} />
        </Text>
      </Flex>
    ),
  },
  {
    Header: "PRIMARY ROLE",
    accessor: "classified_primary_role",
    Cell: ({ value }) => <Text>{value || "-"}</Text>,
  },
  {
    Header: "CONTACT LIMIT EXHAUSTED",
    accessor: "contact_view_limit_exhausted",
    Cell: ({ value, row }) => (
      <a
        href={`/#/admin/user-usage?searchText=${row.original.owner_phone}`}
        target="_blank"
        rel="noreferrer"
      >
        <Text color={value ? "green.500" : undefined} fontWeight={value ? "bold" : "normal"}>
          {value ? "Yes" : "No"}
        </Text>
      </a>
    ),
  },
  {
    Header: "AI COMMENT",
    accessor: "classified_comment",
    Cell: ({ value = "" }) => (
      <Flex align="center" justify="center">
        {value?.length > 30 ? (
          <Tooltip label={value} aria-label="A tooltip">
            {`${value?.slice(0, 30)}...`}
          </Tooltip>
        ) : (
          <Text>{value || "-"}</Text>
        )}
      </Flex>
    ),
  },
  {
    Header: "COMMENT",
    accessor: "comment",
    Cell: ({ value = "" }) => (
      <Flex align="center" justify="center">
        {value?.length > 20 ? (
          <Tooltip label={value} aria-label="A tooltip">
            {value?.length > 20 ? `${value?.slice(0, 20)}...` : value}
          </Tooltip>
        ) : (
          <Text>{value || "-"}</Text>
        )}
      </Flex>
    ),
  },
  {
    Header: "COMMENT INFO",
    accessor: "commented_by",
    Cell: ({ value, row }) => {
      const createdStr = row?.original?.commented_at;
      const updatedStr = row?.original?.comment_updated_at;
      if (!value && !createdStr && !updatedStr) return <Text>-</Text>;
      return (
        <Flex direction="column" align="center" justify="center">
          {value && <Text fontWeight="600">{value}</Text>}
          {createdStr && (
            <Text fontSize="0.65rem" color="gray.600">
              Created: {createdStr}
            </Text>
          )}
          {updatedStr && updatedStr !== createdStr && (
            <Text fontSize="0.65rem" color="gray.600">
              Updated: {updatedStr}
            </Text>
          )}
        </Flex>
      );
    },
  },
  {
    Header: "POSTED ON",
    accessor: "created_at",
  },
   {
    Header: "IP ADDRESS",
    accessor: "created_ip",
    Cell: ({ value }) =>
      value ? (
        <a
          href={`https://whatismyipaddress.com/ip/${value}`}
          target="_blank"
          rel="noreferrer"
          style={{ color: "#3182ce", textDecoration: "underline" }}
        >
          {value}
        </a>
      ) : (
        <Text>-</Text>
      ),
  },
  {
    Header: "TOTAL LEADS",
    accessor: "total_leads",
    Cell: ({ value, row }) => {
      const { _id, user_id } = row.original || {};

      return (
        <a
          _hover={{ textDecoration: "underline" }}
          href={`/#/admin/users/${user_id}?adId=${_id}`}
          target="_blank"
          rel="noreferrer"
          cursor="pointer"
          whiteSpace={"nowrap"}
          style={{ fontWeight: 600, textAlign: "center" }}
        >
          <Text fontSize={18}>{value}</Text>
        </a>
      );
    },
  },
  {
    Header: "CUSTOM LISTING SCORE",
    accessor: "custom_listing_score",
  },


  {
    Header: "LOCATION",
    accessor: "location",
    Cell: ({ value }) => (
      <Text
        cursor="pointer"
        whiteSpace={"nowrap"}
        style={{ fontSize: "11px", fontWeight: 600, textAlign: "left" }}
      >
        {value}
      </Text>
    ),
  },
  {
    Header: "LAST ACTIVITY",
    accessor: "last_activity_at",
  },
  {
    Header: "LISTING SCORE",
    accessor: "listing_score",
  },
  {
    Header: "TRANSACTION TYPE",
    accessor: "collection_type",
  },
  {
    Header: "AD TYPE",
    accessor: "ad_type",
  },
  {
    Header: "PROPERTY TYPE",
    accessor: "property_type",
  },
  {
    Header: "EXPIRES ON",
    accessor: "expires_on",
  },
  {
    Header: "ACTUAL EXPIRY",
    accessor: "actual_expiry",
  },
  {
    Header: "OWNER EMAIL",
    accessor: "owner_email",
    Cell: ({ value }) => (
      <Flex align="center" justify={"center"}>
        <Text cursor="pointer" whiteSpace={"nowrap"}>
          {value !== "-" ? value.slice(0, 10) + "..." : value}
        </Text>
        {value !== "-" ? <CustomTooltip dataLabel={value} /> : null}
      </Flex>
    ),
  },
  {
    Header: "META TITLE",
    accessor: "meta_title",
  },
  {
    Header: "META DESCRIPTION",
    accessor: "meta_description",
    Cell: ({ value }) => (
      <Flex align="center" justify="center">
        <Text cursor="pointer" whiteSpace={"nowrap"}>
          {value.slice(0, 10) + "..."}
        </Text>

        <TooltipModal dataLabel={value} title="Ads Meta Description" />
      </Flex>
    ),
  }
];
